import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Cart from './components/Cart';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import CategoryPage from './pages/CategoryPage';
import CheckoutPage from './pages/CheckoutPage';
import NotFoundPage from './pages/NotFoundPage';
import SearchResultsPage from './pages/SearchResultsPage'; // Importar a nova página
import AdminPage from './pages/AdminPage';
import Login from './components/admin/Login';
import ProtectedRoute from './components/admin/ProtectedRoute';
import { ProductProvider } from './context/ProductContext';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './contexts/AuthContext';
import ScrollToTop from './utils/ScrollToTop'; // Importar ScrollToTop
import './App.css';

function App() {
  return (
    <AuthProvider>
      <ProductProvider>
        <CartProvider>
          <Router>
            <ScrollToTop /> {/* Adicionar ScrollToTop aqui */}
            <div className="app">
              <Header />
              <Cart />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/produto/:code" element={<ProductPage />} />
                  <Route path="/categoria/:category" element={<CategoryPage />} />
                  <Route path="/pesquisa" element={<SearchResultsPage />} />
                  <Route path="/mega-oferta" element={<CategoryPage category="MEGA OFERTA" />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/login" element={<Login />} />
                  
                  {/* Rotas protegidas */}
                  <Route element={<ProtectedRoute />}>
                    <Route path="/admin" element={<AdminPage />} />
                  </Route>
                  
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </main>
              <Footer />
            </div>
          </Router>
        </CartProvider>
      </ProductProvider>
    </AuthProvider>
  );
}

export default App;
